import { toNumber } from './numbers';

const integerFormatter = new Intl.NumberFormat('it-IT', {
  maximumFractionDigits: 0,
});

const compactFormatter = new Intl.NumberFormat('it-IT', {
  notation: 'compact',
  maximumFractionDigits: 1,
});

const currencyFormatter = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
});

const percentFormatter = new Intl.NumberFormat('it-IT', {
  style: 'percent',
  maximumFractionDigits: 0,
});

export function formatDisplayValue(value: unknown, unit: unknown): string {
  const numeric = toNumber(value);
  if (numeric === null) {
    return 'n.d.';
  }

  const normalizedUnit = String(unit ?? '').trim().toLocaleLowerCase('it-IT');
  if (normalizedUnit === '%') {
    return percentFormatter.format(numeric);
  }
  if (normalizedUnit === '€' || normalizedUnit === 'eur') {
    return currencyFormatter.format(numeric);
  }
  if (['gg', 'giorni'].includes(normalizedUnit)) {
    return `${integerFormatter.format(numeric)} gg`;
  }
  if (normalizedUnit === 'ore') {
    return `${integerFormatter.format(numeric)} ore`;
  }
  if (normalizedUnit === 'ore mensili') {
    return `${integerFormatter.format(numeric)} ore/mese`;
  }
  return integerFormatter.format(numeric);
}

export function formatAxisValue(value: number, unit: unknown): string {
  const normalizedUnit = String(unit ?? '').trim().toLocaleLowerCase('it-IT');
  if (normalizedUnit === '%') {
    return percentFormatter.format(value);
  }
  if (normalizedUnit === '€' || normalizedUnit === 'eur') {
    return `€ ${compactFormatter.format(value)}`;
  }
  if (['gg', 'giorni'].includes(normalizedUnit)) {
    return `${integerFormatter.format(value)} gg`;
  }
  if (normalizedUnit.includes('ore')) {
    return `${integerFormatter.format(value)} h`;
  }
  return compactFormatter.format(value);
}
